"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnSupportedChatProvider = void 0;
const react_1 = __importDefault(require("react"));
const ChatContext_1 = require("./ChatContext");
const proxyHelper_1 = require("../helper/proxyHelper");
const UnSupportedChatProvider = ({ children, }) => {
    const unsupportedContext = (0, proxyHelper_1.createUnsupportedProxy)();
    return (react_1.default.createElement(ChatContext_1.ChatContext.Provider, { value: unsupportedContext }, children));
};
exports.UnSupportedChatProvider = UnSupportedChatProvider;
